<p>
  ui-infobar-bottom works!
</p>
